import React, { Component } from 'react'
import { connect } from 'react-redux'
import ReactEcharts from 'echarts-for-react'
import { setSelectedChars } from '../../../actions'
import { getCharGraph, labelPrependAsType, labelAppendAsType, valueAsType } from '../charts.js'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock } from '@fortawesome/free-solid-svg-icons'
import './CharsRow.css'
import i18n from '../../../i18n'

library.add(faClock)

class CharsRow extends Component {
  setSelectedChars(char) {
    this.props.setSelectedChars(char)
  }

  getValues(name, type, data) {
    const values = []
    for (let i = 0; i < data.length; i++) {
      const fund = data[i]
      let value = '-'
      if (fund.aggregateFundamentals) {
        const fundamentals = fund.aggregateFundamentals[fund.aggregateFundamentals.length - 1]
        if (fundamentals.keys) {
          const index = fundamentals.keys.indexOf(name)
          if (index !== -1) {
            value = labelPrependAsType(type, fund.entityCCY) + valueAsType(fundamentals.values[index], type) + labelAppendAsType(type)
          }
        }
      }
      values.push(value)
    }
    return values
  }

  render() {
    const { data, selectedChars, displayName, charName, charType, minmax } = this.props
    const withAggs = data.filter(x => x.aggregateFundamentals !== null)
    const values = this.getValues(charName, charType, withAggs)
    const columns = values.map((value, idx) => {
      return (
        <td key={idx} className='textCenter'>
          {value}
        </td>
      )
    })
    const colCount = 1 + values.length

    if (values.filter(x => x !== '-').length > 0) {
      return (
        <tbody>
          <tr>
            <td className='textLeft'>
              <div onClick={() => this.setSelectedChars(charName)} style={{ cursor: 'pointer' }}>
                {selectedChars.findIndex(x => x === charName) === -1 && <FontAwesomeIcon style={{ color: '#050139' }} icon='clock' />}
                {selectedChars.findIndex(x => x === charName) !== -1 && <FontAwesomeIcon style={{ color: '8C959B' }} icon='clock' />}
                &nbsp;&nbsp;{i18n.t(displayName)}
              </div>
            </td>
            {columns}
          </tr>
          {selectedChars.findIndex(x => x === charName) !== -1 && (            
            <tr>
              <td colSpan={colCount}>
                <ReactEcharts 
                  option={getCharGraph(displayName, charName, charType, minmax, withAggs)}
                  notMerge={true}
                  theme='default' style={{ height: 300 }} 
                />
              </td>
            </tr>
          )}
        </tbody>
      )
    } else {
      return null
    }
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,
    selectedChars: state.params.selectedChars,
  }
}

export default connect(mapStateToProps, {
  setSelectedChars,
})(CharsRow)
